import * as React from 'react';
import moment from 'moment-timezone';
import { useLocation } from 'react-router-dom';
import { Arbeitszeit } from './Arbeitszeit';

export const ArbeitszeitPrint: React.FC = () => {
    const location = useLocation();
    const urlSearchParams = new URLSearchParams(location.search);

    const betrNrS = urlSearchParams.get('betrNr');
    const betrNr = betrNrS ? parseInt(betrNrS, 10) : moment().year();

    const workYearS = urlSearchParams.get('workYear');
    const workYear = workYearS ? parseInt(workYearS, 10) : moment().year();

    const workMonthS = urlSearchParams.get('workMonth');
    const workMonth = workMonthS ? parseInt(workMonthS, 10) : moment().year();

    return <Arbeitszeit betrNr={betrNr} workYear={workYear} workMonth={workMonth} printView />;
};
